<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('pages.about1')">
              <my-form ref="about1" />
            </b-tab>
            <b-tab :title="$t('pages.about2')">
              <my-form ref="about2" />
            </b-tab>
            <b-tab :title="$t('pages.about3')">
              <my-form ref="about3" />
            </b-tab>
            <b-tab :title="$t('pages.about4')">
              <my-form ref="about4" />
            </b-tab>
            <b-tab :title="$t('pages.about5')">
              <my-form ref="about5" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import FormVue from "./components/Form.vue";
import Controller from "@/Controllers/PagesController";
import LanguagesController from "@/Controllers/LanguagesController";

export default {
  components: {
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      pages: [],
    };
  },
  async created() {
    let pages = await new Controller().GetAll({ filter: "slug|about" });
    let languages = await new LanguagesController().GetActivelanguages();

    this.$refs.about1.SetData(pages[0], languages);
    this.$refs.about2.SetData(pages[1], languages);
    this.$refs.about3.SetData(pages[2], languages);
    this.$refs.about4.SetData(pages[3], languages);
    this.$refs.about5.SetData(pages[4], languages);
   },
};
</script>
